import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-repaymentfooter',
  templateUrl: './repaymentfooter.component.html',
  styleUrls: ['./repaymentfooter.component.css']
})
export class RepaymentfooterComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
